module.exports = __webpack_public_path__ + "img/loading.fa6d4861.gif";